import { FC, PropsWithChildren } from 'react'

import Show from '@components/helpers/Show'
import Typography from '@/ui/components/typography'
import { InfoItemWrapper } from './infoItem.styles'

interface InfoItemProps extends PropsWithChildren {
    title?: string
    className?: string
    dataTestId?: string
}

const InfoItem: FC<InfoItemProps> = ({
    children,
    title,
    className,
    dataTestId,
}) => {
    return (
        <InfoItemWrapper
            className={`info-item${className ? ` ${className}` : ''}`}
            data-testid={title}
        >
            <Show when={title}>
                <Typography className="title" component="h3" variant="s-regular">
                    {title}
                </Typography>
            </Show>
            <Typography
                className="content"
                variant="s-regular"
                noWrap={false}
                testId={dataTestId}
            >
                {children}
            </Typography>
        </InfoItemWrapper>
    )
}

export default InfoItem
